module.exports = __webpack_public_path__ + "img/thumbnail_BengalTiger_j_albino.2bbf47f0.png";